<puro-modal
  class="get-labels-cancelled-shipment-dialog__modal"
  [className]="'get-labels-cancelled-shipment-dialog__modal'"
  [open]="open()"
  [title]="modalTitle()"
  size="medium"
  [showCloseButton]="false"
  [closeOnBackdrop]="false"
  [actions]="actions()"
  data-testid="get-labels-cancelled-shipment-dialog"
>
  <puro-typography component="p" variant="body1" class="get-labels-cancelled-shipment-dialog__body">
    {{ bodyText() }}
  </puro-typography>
</puro-modal>
